import { render } from "./AdmissionConfigLogSection.vue?vue&type=template&id=3384afae&scoped=true"
import script from "./AdmissionConfigLogSection.vue?vue&type=script&lang=js"
export * from "./AdmissionConfigLogSection.vue?vue&type=script&lang=js"

import "./AdmissionConfigLogSection.vue?vue&type=style&index=0&id=3384afae&scoped=true&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3384afae"]])

export default __exports__